import styled from "styled-components";
import AirbnbMsool from "../../../../../assets/svg/AirbnbMsool.svg?react";

interface ResponsiveProps {
  $isPhone?: boolean;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalBox = styled.div<ResponsiveProps>`
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "850px")};
  max-width: 100%;
  text-align: start;
  direction: rtl;
  /* All padding is now here */
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "32px")};
  box-sizing: border-box;
`;

export const ModalTitle = styled.span<ResponsiveProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "17px" : "24px")};
  width: 100%;
  font-weight: 700;
  color: #331860;
`;

export const ModalDescription = styled.span<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "508px")};
  font-size: ${({ $isPhone }) => ($isPhone ? "13px" : "16px")};
  font-weight: 400;
  color: #625783;
  text-align: start;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e2e8f0;
  margin-top: 16px;
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "flex-end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  background: white;
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width }) => $width || "auto"};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }
`;

export const CloseButtonContainer = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 64px;
  cursor: pointer;
`;

export const ContentWrapper = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 782px;
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "451px")};
`;

export const StyledAirbnbIcon = styled(AirbnbMsool)<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "120px" : "160px")};
  height: ${({ $isPhone }) => ($isPhone ? "56px" : "74px")};
`;

export const TitleSection = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const FoundText = styled.span<ResponsiveProps>`
  display: flex;
  font-weight: 400;
  font-size: 12px;
  margin-top: 15px;
  color: #5b3fff;
  text-align: start;
  width: 100%;
`;

export const SelectAllBox = styled.div<ResponsiveProps>`
  width: 114px;
  height: 32px;
  border-radius: 40px;
  box-shadow: 0px 0px 0px 1px #21212613;
  border: 1px solid #21212613;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
`;

export const PropertyGrid = styled.div<ResponsiveProps>`
  display: grid;
  grid-template-columns: ${({ $isPhone }) =>
    $isPhone ? "repeat(2, 1fr)" : "repeat(4, 1fr)"};
  gap: 10px;
  overflow-y: auto;
  height: ${({ $isPhone }) => ($isPhone ? 250 : 330)}px;
  margin-top: 16px;
`;

export const PropertyWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;
